export default __webpack_public_path__ + "locales/ar-SA/Settings.json?hash=c12c45b0f6e3f832d1acb5e042abb5c9";